import { MarketplaceState, MarketplaceActionTypes } from "../types";
import slidingMenuConstants from "../../constants/slidingMenuConstats";
import {
  FETCH_APPS_FAILURE,
  FETCH_APPS_SUCCESS,
  FETCH_DEPLOYMENT_TYPES_FAILURE,
  FETCH_DEPLOYMENT_TYPES_SUCCESS,
  SET_ERROR_MESSAGE,
  SET_FORM_DATA,
  SET_FORM_ERRORS,
  SET_SAVE_CREDENTIALS,
  SET_SELECTED_APP,
  SET_SELECTED_DEPLOYMENT_TYPE,
  RESET_FORM,
  FETCH_CATEGORIES_SUCCESS,
  FETCH_CATEGORIES_FAILURE,
} from "./constants";

const initialState: MarketplaceState = {
  apps: [],
  categories: [],
  deploymentTypes: [],
  selectedApp: null,
  formErrors: {},
  errorMessage: "",
  formData: {},
  saveCredentials: false,
  selectedDeploymentType: null,
  loading: false,
};

const marketplace = (
  state = initialState,
  action: MarketplaceActionTypes,
): MarketplaceState => {
  switch (action.type) {
    case FETCH_APPS_SUCCESS:
      return {
        ...state,
        apps: action.payload,
      };
    case FETCH_APPS_FAILURE:
      return {
        ...state,
      };
    case FETCH_DEPLOYMENT_TYPES_SUCCESS:
      return {
        ...state,
        deploymentTypes: action.payload,
      };
    case FETCH_DEPLOYMENT_TYPES_FAILURE:
      return {
        ...state,
      };
    case SET_SELECTED_APP:
      return {
        ...state,
        selectedApp: action.payload,
      };
    case SET_SELECTED_DEPLOYMENT_TYPE:
      return {
        ...state,
        selectedDeploymentType: action.payload,
      };
    case SET_FORM_DATA:
      return {
        ...state,
        formData: action.payload,
      };
    case SET_SAVE_CREDENTIALS:
      return {
        ...state,
        saveCredentials: action.payload,
      };
    case SET_FORM_ERRORS:
      return {
        ...state,
        formErrors: action.payload,
      };
    case SET_ERROR_MESSAGE:
      return {
        ...state,
        errorMessage: action.payload,
      };
    case RESET_FORM:
      return {
        ...state,
        selectedDeploymentType: null,
        formData: {},
        saveCredentials: false,
        formErrors: {},
        errorMessage: "",
      };
    case slidingMenuConstants.SLIDING_MENU_LAYER_CLOSE:
      return {
        ...state,
        selectedDeploymentType: null,
        formData: {},
        saveCredentials: false,
        formErrors: {},
        errorMessage: "",
      };
    case FETCH_CATEGORIES_SUCCESS:
      return {
        ...state,
        categories: action.payload,
      };
    case FETCH_CATEGORIES_FAILURE:
      return {
        ...state,
      };
    default:
      return state;
  }
};

export default marketplace;
